/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum UserStatus {
  New = "New",
  PendingPersonalInformation = "PendingPersonalInformation",
  Blocked = "Blocked",
  PendingKycVerification = "PendingKycVerification",
  Active = "Active",
  PendingSelectCategories = "PendingSelectCategories",
}

export enum ReviewType {
  CustomerToHandyman = "CustomerToHandyman",
  HandymanToCustomer = "HandymanToCustomer",
}

export enum ReviewStatus {
  Pending = "Pending",
  Submitted = "Submitted",
  Expired = "Expired",
}

export enum OrderStatus {
  New = "New",
  InProgress = "InProgress",
  Completed = "Completed",
  MarkAsDone = "MarkAsDone",
}

export enum OrderProposalStatus {
  Requested = "Requested",
  Rejected = "Rejected",
  Cancelled = "Cancelled",
  Confirmed = "Confirmed",
}

export enum OrderPaymentStatus {
  Pending = "Pending",
  PaymentInitiated = "PaymentInitiated",
  Processing = "Processing",
  Paid = "Paid",
  Failed = "Failed",
  Canceled = "Canceled",
  Refunded = "Refunded",
}

export enum MessageEventType {
  OrderProposalSent = "OrderProposalSent",
  OrderProposalRejected = "OrderProposalRejected",
  OrderProposalAccepted = "OrderProposalAccepted",
  OrderStatusChanged = "OrderStatusChanged",
  OrderCompleted = "OrderCompleted",
  PaymentReceived = "PaymentReceived",
  ReviewSubmitted = "ReviewSubmitted",
}

export enum InputFieldType {
  Checkbox = "Checkbox",
  Slider = "Slider",
  Text = "Text",
  TextArea = "TextArea",
  Dropdown = "Dropdown",
  Number = "Number",
}

export enum EventType {
  Register = "Register",
  ForgotPassword = "ForgotPassword",
  ChangePassword = "ChangePassword",
  ChangeAccountDetails = "ChangeAccountDetails",
}

export enum CommunicationChannel {
  Sms = "Sms",
  Email = "Email",
  PushNotification = "PushNotification",
}

export enum ChatMessageType {
  User = "User",
  Event = "Event",
}

export enum ChatMessageStatus {
  Sending = "Sending",
  Sent = "Sent",
  Delivered = "Delivered",
  Read = "Read",
}

export interface ActivityLog {
  /** @format uuid */
  id?: string;
  ipAddress?: string | null;
  /** @format date-time */
  timestamp?: string;
  url?: string | null;
  userAgent?: string | null;
  /** @format uuid */
  userId?: string;
  data?: string | null;
}

export interface BrowseAvailableForHandymanOrdersQuery {
  address?: string | null;
  /** @format double */
  radiusKm?: number | null;
  languageKey?: string | null;
}

export interface BrowseHandymanQuery {
  address?: string | null;
  /** @format double */
  radiusKm?: number | null;
}

export interface CategoryAttributeViewModel {
  /** @format uuid */
  id?: string;
  inputType?: InputFieldType;
  translatedDropdownOption?: TranslatedDropdownOptionViewModel;
  translatedAtributeContent?: TranslatedAtributeContentViewModel;
}

export interface CategoryViewModel {
  /** @format uuid */
  id?: string;
  key?: string | null;
  isRootCategory?: boolean;
  parentCategoryKey?: string | null;
  description?: string | null;
  name?: string | null;
  subcategories?: CategoryViewModel[] | null;
}

export interface ChatDetailsViewModel {
  /** @format uuid */
  id?: string;
  title?: string | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  participants?: ChatParticipantViewModel[] | null;
  messages?: ChatMessageViewModel[] | null;
}

export interface ChatMessageEventViewModel {
  /** @format uuid */
  chatMessageId?: string;
  eventType?: MessageEventType;
  /** @format uuid */
  orderId?: string | null;
  /** @format uuid */
  orderProposalId?: string | null;
  title?: string | null;
  content?: string | null;
}

export interface ChatMessageViewModel {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  chatId?: string;
  /** @format uuid */
  senderId?: string;
  chatMessageType?: ChatMessageType;
  content?: string | null;
  /** @format date-time */
  timestamp?: string;
  status?: ChatMessageStatus;
  attachmentBase64?: string | null;
  eventDetails?: ChatMessageEventViewModel;
}

export interface ChatParticipantViewModel {
  /** @format uuid */
  userId?: string;
  userDetails?: UserDetailsViewModel;
  /** @format date-time */
  joinedAt?: string;
}

export interface ChatViewModel {
  /** @format uuid */
  id?: string;
  title?: string | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  participants?: ChatParticipantViewModel[] | null;
  lastMessage?: string | null;
}

export interface CreateChatCommand {
  title?: string | null;
  participantIds?: string[] | null;
}

export interface CreateCheckoutSessionResultViewModel {
  sessionId?: string | null;
}

export interface CreateOrderAttributeViewModel {
  /** @format uuid */
  categoryAttributeId?: string;
  value?: string | null;
}

export interface CreateOrderCommand {
  categoryKey?: string | null;
  name?: string | null;
  description?: string | null;
  location?: string | null;
  /** @format uuid */
  handymanId?: string | null;
  orderAttributeAnswers?: CreateOrderAttributeViewModel[] | null;
  /** @format date-time */
  dueDateUtc?: string | null;
  /** @format double */
  price?: number | null;
  base64Images?: string[] | null;
  address?: string | null;
}

export interface CreatePaymentIntentResultViewModel {
  clientSecret?: string | null;
}

export interface CreateReviewCommand {
  /** @format uuid */
  orderId?: string;
  /** @format uuid */
  reviewerId?: string;
  /** @format uuid */
  revieweeId?: string;
  /** @format int32 */
  rating?: number;
  comment?: string | null;
  tags?: string[] | null;
  type?: ReviewType;
}

export interface DropdownOptionViewModel {
  value?: string | null;
  label?: string | null;
}

export interface ForgotPasswordCommand {
  phoneNumber?: string | null;
  password?: string | null;
  code?: string | null;
  otpCommunicationChannel?: CommunicationChannel;
}

export interface GetChatByParticipantsQuery {
  participantIds?: string[] | null;
}

export interface GetReviewsQueryResult {
  reviews?: ReviewViewModel[] | null;
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  currentPage?: number;
}

export interface HandymanViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  updateAt?: string;
  status?: UserStatus;
  phone?: string | null;
  email?: string | null;
  avatarUrl?: string | null;
  categories?: UserCategoryShortViewModel[] | null;
  gender?: string | null;
  /** @format date-time */
  birthDate?: string | null;
  location?: string | null;
  bio?: string | null;
  userPortfolioItems?: UserPortfolioItemViewModel[] | null;
  fullName?: string | null;
  isVerified?: boolean;
}

export interface OrderAttributeAnswerViewModel {
  /** @format uuid */
  id?: string;
  categoryAttribute?: CategoryAttributeViewModel;
  value?: string | null;
}

export interface OrderProposalViewModel {
  /** @format uuid */
  id?: string;
  order?: OrderViewModel;
  status?: OrderProposalStatus;
  /** @format uuid */
  customerId?: string;
  /** @format uuid */
  handymanId?: string;
  isInitiatedByCustomer?: boolean;
  handyman?: UserDetailsViewModel;
}

export interface OrderReviewViewModel {
  /** @format uuid */
  id?: string;
  reviewer?: UserDetailsViewModel;
  /** @format int32 */
  rating?: number;
  comment?: string | null;
  tags?: string[] | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  isVisible?: boolean;
  type?: ReviewType;
  status?: ReviewStatus;
  response?: string | null;
  /** @format date-time */
  responseDate?: string | null;
}

export interface OrderViewModel {
  /** @format uuid */
  id?: string;
  category?: CategoryViewModel;
  name?: string | null;
  description?: string | null;
  location?: string | null;
  status?: OrderStatus;
  handyman?: UserDetailsViewModel;
  customer?: UserDetailsViewModel;
  orderAttributeAnswers?: OrderAttributeAnswerViewModel[] | null;
  /** @format date-time */
  createdAtUtc?: string;
  /** @format date-time */
  dueDateUtc?: string | null;
  /** @format double */
  price?: number | null;
  base64Images?: string[] | null;
  reviews?: OrderReviewViewModel[] | null;
  address?: string | null;
  paymentStatus?: OrderPaymentStatus;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface RegisterUserCommand {
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  password?: string | null;
  otpCode?: string | null;
  email?: string | null;
  otpContactReference?: string | null;
  otpCommunicationChannel?: CommunicationChannel;
  address?: string | null;
  /** @format uuid */
  roleId?: string;
  avatarUrl?: string | null;
}

export interface ReviewViewModel {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  orderId?: string;
  reviewer?: UserDetailsViewModel;
  reviewee?: UserDetailsViewModel;
  /** @format int32 */
  rating?: number;
  comment?: string | null;
  tags?: string[] | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  isVisible?: boolean;
  type?: ReviewType;
  status?: ReviewStatus;
  response?: string | null;
  /** @format date-time */
  responseDate?: string | null;
}

export interface SelectUserCategoriesCommand {
  categoryKeys?: string[] | null;
}

export interface SendChatMessageCommand {
  /** @format uuid */
  chatId?: string;
  chatMessageType?: ChatMessageType;
  content?: string | null;
  attachmentBase64?: string | null;
  eventType?: MessageEventType;
  /** @format uuid */
  orderId?: string | null;
  /** @format uuid */
  orderProposalId?: string | null;
  eventTitle?: string | null;
  eventContent?: string | null;
}

export interface SendOrderProposalToCustomerCommand {
  /** @format uuid */
  orderId?: string;
}

export interface SendOrderProposalToHandymanCommand {
  /** @format uuid */
  orderId?: string;
  /** @format uuid */
  handymanId?: string;
}

export interface SendOtpCodeCommand {
  contactReference?: string | null;
  eventType?: EventType;
  otpCommunicationChannel?: CommunicationChannel;
}

export interface SubmitReviewCommand {
  /** @format uuid */
  reviewId?: string;
  languageKey?: string | null;
}

export interface TranslatedAtributeContentViewModel {
  defaultValue?: string | null;
  placeholder?: string | null;
  label?: string | null;
}

export interface TranslatedDropdownOptionViewModel {
  options?: DropdownOptionViewModel[] | null;
}

export interface UpdatePasswordCommand {
  password?: string | null;
  otpCode?: string | null;
  otpCommunicationChannel?: CommunicationChannel;
}

export interface UpdateProposalByHandymanCommand {
  status?: OrderProposalStatus;
  /** @format uuid */
  orderProposalId?: string;
  languageKey?: string | null;
}

export interface UpdateUserAvatarCommand {
  avatarBase64?: string | null;
}

export interface UpdateUserCategoryRatesCommand {
  categoryKey?: string | null;
  /** @format double */
  hourlyRate?: number;
  hourlyRateCurrencyKey?: string | null;
  /** @format double */
  fixedPriceRate?: number;
  fixedPriceRateCurrencyKey?: string | null;
}

export interface UpdateUserDetailsCommand {
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  email?: string | null;
  location?: string | null;
  /** @format date-time */
  birthDate?: string | null;
  gender?: string | null;
  otpCode?: string | null;
  otpCommunicationChannel?: CommunicationChannel;
  bio?: string | null;
  serviceArea?: string | null;
}

export interface UpdateUserPortfolioItemsCommand {
  userPortfolioItems?: UserPortfolioItemViewModel[] | null;
}

export interface UserAddress {
  /** @format uuid */
  id?: string;
  street?: string | null;
  street2?: string | null;
  city?: string | null;
  region?: string | null;
  postalCode?: string | null;
  country?: string | null;
}

export interface UserCategoryShortViewModel {
  categoryKey?: string | null;
  /** @format double */
  hourlyRate?: number;
  hourlyRateCurrencyKey?: string | null;
  /** @format double */
  fixedPriceRate?: number;
  fixedPriceRateCurrencyKey?: string | null;
}

export interface UserCategoryViewModel {
  /** @format uuid */
  id?: string;
  name?: string | null;
  key?: string | null;
  isRootCategory?: boolean;
  parentCategoryKey?: string | null;
  /** @format double */
  hourlyRate?: number;
  hourlyRateCurrencyKey?: string | null;
  /** @format double */
  fixedPriceRate?: number;
  fixedPriceRateCurrencyKey?: string | null;
  subcategories?: UserCategoryViewModel[] | null;
}

export interface UserCompany {
  /** @format uuid */
  id?: string;
  name?: string | null;
}

export interface UserDetailsViewModel {
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  address?: UserAddress;
  status?: UserStatus;
  email?: string | null;
  company?: UserCompany;
  /** @format uuid */
  roleId?: string;
  avatarUrl?: string | null;
  gender?: string | null;
  /** @format date-time */
  birthDate?: string | null;
  location?: string | null;
  bio?: string | null;
  /** @format uuid */
  id?: string;
  serviceAreaAddress?: string | null;
  serviceAreaJson?: string | null;
  /** @format double */
  balance?: number | null;
  isStripeAccountVerified?: boolean;
  /** @format double */
  balanceInTransfer?: number | null;
}

export interface UserPortfolioItemViewModel {
  /** @format uuid */
  id?: string;
  name?: string | null;
  description?: string | null;
  categoryKeys?: string[] | null;
  base64Images?: string[] | null;
}

export interface WithdrawBalanceCommand {
  /** @format double */
  amount?: number;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Handyman.Api
 * @version 1.0
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  activityLog = {
    /**
     * No description
     *
     * @tags ActivityLog
     * @name ActivityLogCreate
     * @request POST:/activity-log
     */
    activityLogCreate: (data: ActivityLog, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/activity-log`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  browseHandyman = {
    /**
     * No description
     *
     * @tags BrowseHandyman
     * @name BrowseHandymanCreate
     * @request POST:/browse-handyman
     */
    browseHandymanCreate: (
      data: BrowseHandymanQuery,
      params: RequestParams = {},
    ) =>
      this.request<HandymanViewModel[], any>({
        path: `/browse-handyman`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  categories = {
    /**
     * No description
     *
     * @tags Categories
     * @name UserSelectedList
     * @request GET:/categories/user-selected
     */
    userSelectedList: (
      query?: {
        userId?: string;
        languageKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserCategoryViewModel[], any>({
        path: `/categories/user-selected`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Categories
     * @name CategoriesUpdate
     * @request PUT:/categories
     */
    categoriesUpdate: (
      data: UpdateUserCategoryRatesCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/categories`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Categories
     * @name CategoriesList
     * @request GET:/categories
     */
    categoriesList: (
      query?: {
        languageKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CategoryViewModel[], any>({
        path: `/categories`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Categories
     * @name AttributesList
     * @request GET:/categories/{categoryKey}/attributes
     */
    attributesList: (
      categoryKey: string,
      query?: {
        languageKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CategoryAttributeViewModel[], any>({
        path: `/categories/${categoryKey}/attributes`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  chats = {
    /**
     * No description
     *
     * @tags Chats
     * @name ChatsList
     * @request GET:/chats
     */
    chatsList: (params: RequestParams = {}) =>
      this.request<ChatViewModel[], any>({
        path: `/chats`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name ChatsCreate
     * @request POST:/chats
     */
    chatsCreate: (data: CreateChatCommand, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/chats`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name ChatsDetail
     * @request GET:/chats/{chatId}
     */
    chatsDetail: (chatId: string, params: RequestParams = {}) =>
      this.request<ChatDetailsViewModel, any>({
        path: `/chats/${chatId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name MessagesCreate
     * @request POST:/chats/{chatId}/messages
     */
    messagesCreate: (
      chatId: string,
      data: SendChatMessageCommand,
      params: RequestParams = {},
    ) =>
      this.request<ChatMessageViewModel, any>({
        path: `/chats/${chatId}/messages`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name CreateOrGetChatCreate
     * @request POST:/chats/create-or-get-chat
     */
    createOrGetChatCreate: (
      data: GetChatByParticipantsQuery,
      params: RequestParams = {},
    ) =>
      this.request<ChatMessageViewModel, any>({
        path: `/chats/create-or-get-chat`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  handymanOrders = {
    /**
     * No description
     *
     * @tags HandymanOrders
     * @name AvailableOrdersCreate
     * @request POST:/handyman-orders/available-orders
     */
    availableOrdersCreate: (
      data: BrowseAvailableForHandymanOrdersQuery,
      params: RequestParams = {},
    ) =>
      this.request<OrderViewModel, any>({
        path: `/handyman-orders/available-orders`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags HandymanOrders
     * @name ProposalsList
     * @request GET:/handyman-orders/proposals
     */
    proposalsList: (
      query?: {
        languageKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrderProposalViewModel[], any>({
        path: `/handyman-orders/proposals`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags HandymanOrders
     * @name ProposalsUpdate
     * @request PUT:/handyman-orders/proposals/{orderProposalId}
     */
    proposalsUpdate: (
      orderProposalId: string,
      data: UpdateProposalByHandymanCommand,
      query?: {
        languageKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrderProposalViewModel, any>({
        path: `/handyman-orders/proposals/${orderProposalId}`,
        method: "PUT",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags HandymanOrders
     * @name SendProposalCreate
     * @request POST:/handyman-orders/{orderId}/send-proposal
     */
    sendProposalCreate: (
      orderId: string,
      data: SendOrderProposalToCustomerCommand,
      query?: {
        languageKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrderViewModel, any>({
        path: `/handyman-orders/${orderId}/send-proposal`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags HandymanOrders
     * @name MarkAsDoneCreate
     * @request POST:/handyman-orders/{orderId}/mark-as-done
     */
    markAsDoneCreate: (
      orderId: string,
      query?: {
        languageKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrderProposalViewModel, any>({
        path: `/handyman-orders/${orderId}/mark-as-done`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),
  };
  orders = {
    /**
     * No description
     *
     * @tags OrderPayment
     * @name CreatePaymentIntentCreate
     * @request POST:/orders/{orderId}/create-payment-intent
     */
    createPaymentIntentCreate: (
      orderId: string,
      query?: {
        /** @format uuid */
        orderId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CreatePaymentIntentResultViewModel, any>({
        path: `/orders/${orderId}/create-payment-intent`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderPayment
     * @name StripeWebhookCreate
     * @request POST:/orders/stripe/webhook
     */
    stripeWebhookCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/orders/stripe/webhook`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderPayment
     * @name CreateCheckoutSessionCreate
     * @request POST:/orders/{orderId}/create-checkout-session
     */
    createCheckoutSessionCreate: (
      orderId: string,
      query?: {
        /** @format uuid */
        orderId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CreateCheckoutSessionResultViewModel, any>({
        path: `/orders/${orderId}/create-checkout-session`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderPayment
     * @name WithdrawCreate
     * @request POST:/orders/withdraw
     */
    withdrawCreate: (
      data: WithdrawBalanceCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/orders/withdraw`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name OrdersList
     * @request GET:/orders
     */
    ordersList: (
      query?: {
        languageKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrderViewModel[], any>({
        path: `/orders`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name OrdersCreate
     * @request POST:/orders
     */
    ordersCreate: (
      data: CreateOrderCommand,
      query?: {
        languageKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrderViewModel, any>({
        path: `/orders`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name OrdersDetail
     * @request GET:/orders/{orderId}
     */
    ordersDetail: (
      orderId: string,
      query?: {
        languageKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrderViewModel[], any>({
        path: `/orders/${orderId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name SendProposalCreate
     * @request POST:/orders/{orderId}/send-proposal
     */
    sendProposalCreate: (
      orderId: string,
      data: SendOrderProposalToHandymanCommand,
      query?: {
        languageKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrderViewModel, any>({
        path: `/orders/${orderId}/send-proposal`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name ProposalsList
     * @request GET:/orders/{orderId}/proposals
     */
    proposalsList: (
      orderId: string,
      query?: {
        languageKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrderProposalViewModel[], any>({
        path: `/orders/${orderId}/proposals`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name ProposalsUpdate
     * @request PUT:/orders/proposals/{orderProposalId}
     */
    proposalsUpdate: (
      orderProposalId: string,
      data: UpdateProposalByHandymanCommand,
      query?: {
        languageKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrderProposalViewModel, any>({
        path: `/orders/proposals/${orderProposalId}`,
        method: "PUT",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name CompleteCreate
     * @request POST:/orders/{orderId}/complete
     */
    completeCreate: (
      orderId: string,
      query?: {
        languageKey?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrderProposalViewModel, any>({
        path: `/orders/${orderId}/complete`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),
  };
  reviews = {
    /**
     * No description
     *
     * @tags Reviews
     * @name ReviewsList
     * @request GET:/reviews
     */
    reviewsList: (
      query?: {
        languageKey?: string;
        /** @format uuid */
        userId?: string;
        /** @format uuid */
        orderId?: string;
        type?: ReviewType;
        isVisible?: boolean;
        /**
         * @format int32
         * @default 1
         */
        page?: number;
        /**
         * @format int32
         * @default 10
         */
        pageSize?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetReviewsQueryResult, ProblemDetails>({
        path: `/reviews`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reviews
     * @name ReviewsCreate
     * @request POST:/reviews
     */
    reviewsCreate: (data: CreateReviewCommand, params: RequestParams = {}) =>
      this.request<ReviewViewModel, ProblemDetails>({
        path: `/reviews`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reviews
     * @name UserDetail
     * @request GET:/reviews/user/{userId}
     */
    userDetail: (
      userId: string,
      query?: {
        languageKey?: string;
        /**
         * @format int32
         * @default 1
         */
        page?: number;
        /**
         * @format int32
         * @default 10
         */
        pageSize?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetReviewsQueryResult, ProblemDetails>({
        path: `/reviews/user/${userId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reviews
     * @name OrderDetail
     * @request GET:/reviews/order/{orderId}
     */
    orderDetail: (
      orderId: string,
      query?: {
        languageKey?: string;
        /**
         * @format int32
         * @default 1
         */
        page?: number;
        /**
         * @format int32
         * @default 10
         */
        pageSize?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetReviewsQueryResult, ProblemDetails>({
        path: `/reviews/order/${orderId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reviews
     * @name SubmitCreate
     * @request POST:/reviews/{reviewId}/submit
     */
    submitCreate: (
      reviewId: string,
      data: SubmitReviewCommand,
      params: RequestParams = {},
    ) =>
      this.request<ReviewViewModel, ProblemDetails>({
        path: `/reviews/${reviewId}/submit`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  users = {
    /**
     * No description
     *
     * @tags User
     * @name UsersList
     * @request GET:/users
     */
    usersList: (
      query?: {
        userId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserDetailsViewModel, any>({
        path: `/users`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ExistingEmailCreate
     * @request POST:/users/existing-email
     */
    existingEmailCreate: (
      query?: {
        email?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/users/existing-email`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name PostUsers
     * @request POST:/users/otp
     */
    postUsers: (data: SendOtpCodeCommand, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/users/otp`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name RegisterCreate
     * @request POST:/users/register
     */
    registerCreate: (data: RegisterUserCommand, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/users/register`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ForgotPasswordCreate
     * @request POST:/users/forgot-password
     */
    forgotPasswordCreate: (
      data: ForgotPasswordCommand,
      params: RequestParams = {},
    ) =>
      this.request<boolean, string>({
        path: `/users/forgot-password`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UpdatePasswordCreate
     * @request POST:/users/update-password
     */
    updatePasswordCreate: (
      data: UpdatePasswordCommand,
      params: RequestParams = {},
    ) =>
      this.request<boolean, string>({
        path: `/users/update-password`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name ContactInfoUpdate
     * @request PUT:/users/contact-info
     */
    contactInfoUpdate: (
      data: UpdateUserDetailsCommand,
      params: RequestParams = {},
    ) =>
      this.request<UserDetailsViewModel, any>({
        path: `/users/contact-info`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name AvatarUpdate
     * @request PUT:/users/avatar
     */
    avatarUpdate: (data: UpdateUserAvatarCommand, params: RequestParams = {}) =>
      this.request<UserDetailsViewModel, any>({
        path: `/users/avatar`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name StripeOnboardingLinkList
     * @request GET:/users/stripe/onboarding-link
     */
    stripeOnboardingLinkList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/users/stripe/onboarding-link`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  userOnboarding = {
    /**
     * No description
     *
     * @tags UserOnboarding
     * @name SelectCategoriesCreate
     * @request POST:/user-onboarding/select-categories
     */
    selectCategoriesCreate: (
      data: SelectUserCategoriesCommand,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/user-onboarding/select-categories`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  userPortfolioItems = {
    /**
     * No description
     *
     * @tags UserPortfolioItems
     * @name UserPortfolioItemsUpdate
     * @request PUT:/user-portfolio-items
     */
    userPortfolioItemsUpdate: (
      data: UpdateUserPortfolioItemsCommand,
      params: RequestParams = {},
    ) =>
      this.request<UserPortfolioItemViewModel[], any>({
        path: `/user-portfolio-items`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserPortfolioItems
     * @name UserPortfolioItemsList
     * @request GET:/user-portfolio-items
     */
    userPortfolioItemsList: (
      query?: {
        userId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserPortfolioItemViewModel[], any>({
        path: `/user-portfolio-items`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
}
